import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from 'styled-components';
import { Button } from '../button';
import { getArrowPosition, getTooltipPosition } from './utils'; // arrow dafault shape

var triangleShape = "\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  border-color:".concat(function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey24;
}, ";\n  border-radius: 3px;\n  position: absolute;\n  border: 12px solid ;\n  border-top-color: transparent;\n  border-right-color: #C3C2C8;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n");
export var PopContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // estado inicial => oculto\n  transition: all 0.3s ease-in-out;\n  display: ", ";\n  opacity: ", ";\n\n  // estilos generales\n  width: 300px;\n  padding: 12px;\n  z-index: 10;\n  background-color: #ffffff;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);\n\n   @media (min-width: ", ") {\n    width:324px;    \n  }\n\n  // alineacion del contenido: texto, img, boton\n  align-items: flex-start;\n  justify-content: space-between;\n\n  // ubicacion del popover common\n  position: absolute;\n  ", ";\n\n  // tooltip arrow\n    &:before {\n      ", "\n      ", ";\n    }\n  }\n"])), function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? 'flex' : 'none';
}, function (_ref3) {
  var isVisible = _ref3.isVisible;
  return isVisible ? '1' : '0';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey24;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.screen.lgMin;
}, function (_ref6) {
  var setArrowPos = _ref6.setArrowPos;
  return getTooltipPosition(setArrowPos);
}, triangleShape, function (_ref7) {
  var setArrowPos = _ref7.setArrowPos;
  return getArrowPosition(setArrowPos);
});
export var PopoverArea = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  position: relative;\n  display: inline-block;\n"])), function (_ref8) {
  var fullwidth = _ref8.fullwidth;
  return fullwidth ? '100%' : 'auto';
});
export var Image = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 60px;\n"])));
export var MainContent = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0px 5px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n"])));
export var CustomButton = styled(Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 0px;\n"])));